/**
 * Страница списка. Форма одинакова у `/init` (блок `users`) и у эндпоинтов разделов:
 * `{ items, total, limit, offset }`.
 */

export interface RawPage<T> {
  items?: T[];
  total?: number | null;
  limit?: number | null;
  offset?: number | null;
}

export interface Page<T> {
  items: T[];
  /** Сколько записей всего; null — сервер не сообщил. */
  total: number | null;
  limit: number;
  offset: number;
}

/** Голый массив тоже принимается: тогда считаем, что страница единственная. */
export function mapPage<Raw, Mapped>(
  raw: RawPage<Raw> | Raw[] | undefined,
  mapItem: (item: Raw) => Mapped,
): Page<Mapped> {
  if (Array.isArray(raw)) {
    return { items: raw.map(mapItem), total: raw.length, limit: raw.length, offset: 0 };
  }

  const items = (raw?.items ?? []).map(mapItem);

  return {
    items,
    total: typeof raw?.total === 'number' ? raw.total : null,
    limit: typeof raw?.limit === 'number' ? raw.limit : items.length,
    offset: typeof raw?.offset === 'number' ? raw.offset : 0,
  };
}
